// tslint:disable:max-line-length

import React from 'react';

import { Button, PresetThemes } from '@travelnest/merlin.button';
import { Modal } from '@travelnest/merlin.modal';
import { MarginWrapper } from '@travelnest/merlin.spacer';
import { CalendarSourceStatus, ICalendarSource } from '../../../../data/entities/calendar-source';
import { CalendarSourceInputBlock } from '../../calendar-source/CalendarSourceInputBlock';
import { HelpLink } from '../../help-link/HelpLink';
import { Paragraph } from '../../paragraph/Paragraph';

interface ICalendarSyncImportWizardActionProps {
	propertyId: number | string;
	onRequestNext: () => any;
	onRequestPrevious: () => any;
	onRequestClose: () => any;
	createCalendarSource: (propertyId: number | string, calendarSource: Omit<ICalendarSource, 'id'>) => any;
}

export const CalendarSyncImportWizardActionComponent: React.FC<ICalendarSyncImportWizardActionProps> = (props) => {
	const { onRequestNext, onRequestClose, propertyId, createCalendarSource } = props;
	const [name, setName] = React.useState('');
	const [source, setSource] = React.useState('');
	const [sourceStatus, setSourceStatus] = React.useState<CalendarSourceStatus>();

	const saveAndNext = async () => {
		if (source !== '' && sourceStatus !== 'error') {
			createCalendarSource(propertyId, { property_id: propertyId, source_type: 'ical', source, name });
		}
		onRequestNext();
	};

	const helpLinkUrl = 'https://travelnest.freshdesk.com/support/solutions/articles/101000362817-synchronise-your-travelnest-calendar-with-ical';
	return (
		<Modal
			extraClasses="calendar-sync-modal calendar-sync-modal--import"
			title="Import external calendar"
			onRequestClose={onRequestClose}
			shouldCloseOnOverlayClick={false}
			actionRHS={
				<Button
					id="calendar_import_action_next"
					onClick={saveAndNext}
					buttonType={PresetThemes.Primary}
				>
					<span>Continue</span>
				</Button>
			}
		>
			<MarginWrapper>
				<h3>Import calendar</h3>
				<Paragraph>Importing your calendar means that Travelnest will be notified of bookings received on platforms not managed within your account.</Paragraph>
				<HelpLink to={helpLinkUrl}>How to import external calendars</HelpLink>
				<CalendarSourceInputBlock
					name={name}
					source={source}
					sourceStatus={sourceStatus}
					onChangeName={setName}
					onChangeSource={setSource}
					onChangeStatus={setSourceStatus}
				/>
			</MarginWrapper>
		</Modal>
	);
};
